/**
 * Permission helpers for the admin session idle-timeout policy UI (Issue #289).
 *
 * Backend permission surface:
 *   - GET   /api/v1/admin/session-policy — requires `session_policy:read`
 *     (auto-granted to `*:*` super-admin and to `session_policy:*` wildcards
 *     via the backend `PermissionsGuard`).
 *   - PATCH /api/v1/admin/session-policy — requires `*:*` or
 *     `session_policy:write`.
 *
 * Red lines:
 *   - Helpers only gate UI visibility. Backend remains authoritative.
 */

const SUPER_ADMIN = '*:*';
const SESSION_POLICY_RESOURCE_WILDCARD = 'session_policy:*';
const READ_ACTION_WILDCARD = '*:read';
export const SESSION_POLICY_READ_PERMISSION = 'session_policy:read';
export const SESSION_POLICY_WRITE_PERMISSION = 'session_policy:write';

export function canReadSessionPolicy(permissions: readonly string[]): boolean {
  return (
    permissions.includes(SUPER_ADMIN) ||
    permissions.includes(SESSION_POLICY_RESOURCE_WILDCARD) ||
    permissions.includes(READ_ACTION_WILDCARD) ||
    permissions.includes(SESSION_POLICY_READ_PERMISSION)
  );
}

export function canWriteSessionPolicy(permissions: readonly string[]): boolean {
  return permissions.includes(SUPER_ADMIN) || permissions.includes(SESSION_POLICY_WRITE_PERMISSION);
}
